import React from 'react';
import { Modal } from 'components/common';
import PropTypes from 'prop-types';
import UserForm from './UserForm';

const UserFormModal = ({ show, user, onHide, onSuccess }) => (
  <Modal
    show={show}
    onHide={onHide}
    title={user ? `Edit User — ${user.name || user.full_name || ''}` : 'New User'}
    size="lg"
    backdropClick={false}
  >
    <UserForm
      user={user}
      isModal
      onSuccess={onSuccess}
      onCancel={onHide}
    />
  </Modal>
);

UserFormModal.propTypes = {
  show:      PropTypes.bool.isRequired,
  user:      PropTypes.object,
  onHide:    PropTypes.func.isRequired,
  onSuccess: PropTypes.func
};

UserFormModal.defaultProps = {
  user:      null,
  onSuccess: null
};

export default UserFormModal;
